import React, { useCallback, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getAllNotification, deleteNotification } from '../../../../actions/notificationAction';
import ReactHtmlParser from 'react-html-parser'
import { HOST_URL, MediaBaseUrl } from "../../../../actions/api"; 
import { getInitialRoute, onDeletePop, replaceDomain , TOAST_LOADING} from "../../../../utils";
import { togglePlanSection } from '../../../../actions/show_modal_Action';
import moment from "moment";
import NotificationHeader from "./Components/NotificationHeader";
import { togglePlanSection_D } from "../../../../actions/showDisplayModalAction";
import { updateSelectedCollabratorToken } from "../../../../actions/collabratorAction";
import { WIDGET_WALLS_DATA  } from "../../../../actions/wallsAction";
import { getWidgetWallData } from "../../../../actions/wallDataAction";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";


export default function Notification() {

  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [contentLength, setContentLength] = useState(10);
  const [deletedNotification, setDeletedNotification] = useState(0)
  const dispatch = useDispatch();
  const [sortByNotification, setSortByNotification] = useState(true);
  const [sortByTime, setSortByTime] = useState(true);
  const { notificationList, notificationListLength } = useSelector((state) => state.notification);
  const { collabratorList, selectedCollabrator } = useSelector(state => state.collabratorSection, shallowEqual);
  const [selectedColab, setSelectedCollabrator] = useState(selectedCollabrator ? selectedCollabrator : collabratorList.length > 0 ? collabratorList.filter((collab) => collab.userId === JSON.parse(localStorage.getItem('ownerId')))[0] : []);

  useEffect(() => {
    getNotifications(index);
    // setTimeout(()=>{
    //   dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby:"message",direction:"ASC" }, true));
    // },2000)
  }, []);

  const getNotifications = (pageIndex, direction = 'DESC', sortby = 'createdAt') => {
    TOAST_LOADING();
    dispatch(getAllNotification({ type: "all", synced: 0, created: "", page: pageIndex, perPage: contentLength, sortby: sortby, direction: direction }, false));
  }

  const incrementIndex = (index) => {
    if (((index) * 10) < notificationListLength) {
      setDeletedNotification(0);
      getNotifications(index);
      setIndex(prev => prev + 1);
    }
  }

  const decrementIndex = (index) => {
    if (((index) * 10) >= 0) {
      setDeletedNotification(0);
      getNotifications(index);
      setIndex(prev => prev - 1);
    }
  }

  const changeOwner = (link) => {
    const ownerId = link.split("/");
    collabratorList.map((collabrator) => {
      if (collabrator.userId == ownerId[2]) {
        updateSelectedCollabrator(collabrator)
        return false
      }
    })
  }



  const updateSelectedCollabrator = (collabrator) => {
    if (selectedColab.userId !== collabrator.userId) {
      dispatch(updateSelectedCollabratorToken(collabrator));
      setSelectedCollabrator(collabrator);
      const product = getInitialRoute();
      if (JSON.parse(localStorage.getItem('loginOwnerId')) === collabrator.userId) {
        localStorage.setItem('isCollaborator', 0);
        if (window.location.pathname === `/${product}/walls`) {
          dispatch(WIDGET_WALLS_DATA());
        } else {
          navigate(`/walls/home`);
        }
      } else {
        localStorage.setItem('isCollaborator', 1);
        if (window.location.pathname === `/${product}/walls`) {
          dispatch(WIDGET_WALLS_DATA());
        } else {
          navigate(`/${product}/walls`);
        }
      }
    }
  }

  const getRouteNotification = (link) => {
    const url = link.split('/');
    if (url[0] === 'analytic') {
      dispatch(getWidgetWallData(localStorage.getItem("ownerId"), url[1]))
      setTimeout(() => {
        navigate(`/${link}`)
      }, 1000);

    } else {
      navigate(`/${link}`)
    }
  }

  const getNotificationAction = (action, getNotificationUrl, message, id) => {

    const getNotificationUrlManage = getNotificationUrl.includes("widget") ? getNotificationUrl.replace("https://app.taggbox.com/widget/", "") : getNotificationUrl.includes("display") ? getNotificationUrl.replace("https://app.taggbox.com/display/", "") : getNotificationUrl;

    const changeowner = getNotificationUrlManage.includes("changeowner");

    if (action === 'init') {

      const redirectUrl = getNotificationUrlManage.includes(`${HOST_URL}`) ? replaceDomain(getNotificationUrlManage) : getNotificationUrlManage.replace('Id:', 'Id/');

      return changeowner ? <div onClick={() => { changeOwner(getNotificationUrlManage) }} className={`notification_row my-3 ps-0 cursor-pointer`}>
        {ReactHtmlParser(message)}
      </div> : <>

        <div className={`cursor-pointer notification_row my-3 ps-0`} onClick={() => { getRouteNotification(redirectUrl) }}> {ReactHtmlParser(message)}</div>
      </>

    } else if (action === 'popup') {
      return <a className={`notification_row my-3 ps-0`} onClick={() => getInitialRoute() != 'widget' ? dispatch(togglePlanSection_D(true)) : dispatch(togglePlanSection(true))}>
        {ReactHtmlParser(message)}
      </a>
    } else if (action === 'ugc') {
      return <a href={getNotificationUrl} className={`notification_row my-3 ps-0`} target='_blank'>
        {ReactHtmlParser(message)}
      </a>
  }
    return <Link to={`/${getNotificationUrl}`} className={`notification_row my-3 ps-0`}>
      {ReactHtmlParser(message)}
    </Link>
  }

  const removeNotification = useCallback((id) => {
    onDeletePop(() => {
      if ((Math.trunc((notificationListLength - 1) / 10) > 0) && ((notificationList.length - 1) === 0) && index === 0) {
        incrementIndex(index + 1);
      } else if ((Math.trunc((notificationListLength - 1) / 10) > 0) && (((notificationListLength - 1) % 10) === 0)) {
        decrementIndex(index - 1)
      }
      setDeletedNotification(prev => prev + 1);
      dispatch(deleteNotification(id))
    });
  }, [deletedNotification, notificationListLength])

  const sortNotificationById = (direction) => {
    setSortByNotification(false);
    if (!sortByTime) {
      setSortByTime(true);
    }
    getNotifications(index, direction, 'message');
  }

  const sortNotificationByTimeStamp = (direction) => {
    setSortByTime(false);
    if (!sortByNotification) {
      setSortByNotification(true);
    }
    getNotifications(index, direction, 'createdAt');
  }

  return (
    <div className="d-flex flex-column-fluid main_content no_subheader all_notifications__">
      <div className="container">
        <div className="portlet-body mb-10">
          {notificationList.length > 0
            ? <div className="table-responsive bg-white rounded-2 p-5">
              <table className="table table-hover table-light notification-heading">
                <thead>
                  <tr className="uppercase">
                    <th></th>
                    <NotificationHeader sortFun={(direction) => sortNotificationById(direction)} displayIcon={sortByNotification} name={'Notification'} />
                    <NotificationHeader sortFun={(direction) => sortNotificationByTimeStamp(direction)} displayIcon={sortByTime} name={'Created'} />
                  </tr>
                </thead>
                <tbody>
                  {notificationList.map((notification) => {
                    const { message, id, getNotificationUrl, createdAt, action } = notification;

                    return (
                      <tr id={`notificationsrecord${id}`} key={id}>
                        <td>
                          <div className="md-checkbox checkbox-inline">
                            <div className="btn-group recordControls">
                              <Button variant="link" className="p-2" onClick={() => removeNotification(id)} data-href={`/widget/notifications/delete/${id}`}>
                                <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'fs-5'} />
                              </Button>{" "}
                            </div>
                          </div>
                        </td>
                        <td style={{ minWidth: 200 + "px" }}>
                          {getNotificationAction(action, getNotificationUrl, message, id)}
                        </td>
                        <td style={{ minWidth: 130 + "px" }}>
                          <span>{moment(new Date(createdAt * 1000)).fromNow()}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="row">
                <div className="col-md-12 text-center">
                  <span className="me-3">{contentLength * (index) + 1} - {(contentLength * (index) + 10) <= notificationListLength ? ((contentLength * (index) + 10) - deletedNotification) : (notificationListLength)} of {notificationListLength}</span>
                  <Button variant="light" size="sm" type="text" className="btn-icon me-2" onClick={() => decrementIndex(index - 1)}>
                    <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={'fs-6'} />
                  </Button>
                  <Button variant="light" size="sm" type="text" className="btn-icon" onClick={() => incrementIndex(index + 1)}>
                    <FontAwesomeIcon type={'regular'} icon={'angle-right'} iconClass={'fs-6'} />
                  </Button>
                </div>
              </div>
            </div> :
            <div className="py-8">
              <div className="card card-custom">
                <div className="card-body pt-5 pb-4 d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 220px)' }}>
                  <div className="text-center py-10 mb-10">
                    <img src={`${MediaBaseUrl}error/drop-box.svg`} className="img-fluid my-10" style={{ maxWidth: 200 }} />
                    <h5>Oops! Nothing found</h5>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
